import { accountsEnvironment } from '../accounts-environment';
import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { webApplicationSchema } from '../schemas/web-application.schema';
import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

/**
 * Used by a Trimble Maps partner to get a list of products available to assign to a fleet's account
 * @returns Applications available to assign to a fleet's account
 */
export function getApplications(this: unknown) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(`${accountsEnvironment.resolve(this).applicationsUrl}`, {
        method: 'GET',
        headers: {
          ...requiredHeaders,
          ...jwtAuthHeaders,
        },
      })
    )
  ).pipe(
    selectData(
      z.array(
        webApplicationSchema.omit({
          users: true,
        })
      )
    )
  );
}
